import styled from "styled-components/macro";

export const ImgRr = styled.img`
  grid-area: rr;
`;

export const NoAlarmContainer = styled.div`
  position: absolute;
  bottom: ${({ landscape }) => (landscape ? "10%" : "13%")};
  left: ${({ landscape }) => (landscape ? "4%" : "4%")};

  background: black;
  width: ${({ landscape }) => (landscape ? "30px" : "55px")};

  padding-top: ${({ landscape }) => (landscape ? "1em" : "1em")};
  /* padding-bottom:${({ landscape }) => (landscape ? "0" : "1em")} ; */
`;

export const ContainerDiv = styled.div`
  position: absolute;
  height: ${({ landscape }) => (landscape ? "20px" : "20px")};
  width: auto;
  right: ${({ landscape }) => (landscape ? "79%" : "62%")};
  top: ${({ landscape }) => (landscape ? "60%" : "60%")};
  z-index: 199909;
`;

export const NoAlarmImg = styled.img`
  /* position: absolute;
  height: ${({ landscape }) => (landscape ? "20px" : "15px")};
  width: auto;
  right: ${({ landscape }) => (landscape ? "79%" : "29%")};
  top: ${({ landscape }) => (landscape ? "60%" : "4%")};
  padding: 0;
  margin: 0; */
`;
